export enum BrightcoveEvent {
  LOAD_START = 'loadstart',
  LOADED_DATA = 'loadeddata',
  PLAY = 'play',
  PAUSE = 'pause',
  TIME_UPDATE = 'timeupdate',
  ENDED = 'ended'
}

export interface BrightcoveConfiguration {
  brightcoveAccount: string;
  brightcovePlayer: string;
  brightcoveURL: string;
  brightcoveVideoOverlay: number;
  videoProgressInterval: number;
  minRecommendationCount?: number;
}

export interface BrightcoveOptions {
  autoplay?: boolean;
  muted?: boolean;
}

export interface BrightcovePlayer {
  mediainfo: BrightcovePlayerMediaInfo;
  catalog: BrightcovePlayerCatalog;
  ready(callback: () => void): void;
  // string union has been added to fix fromEvent typing. FromEventTarget is not exported from rxjs which prevents type casting
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  on(event: BrightcoveEvent | string, callback: Function): void;
  off(event: BrightcoveEvent | string): void;
  dispose(): void;
  play(): void;
  currentTime(seconds?: number): number;
  textTracks(): Array<BrightcoveTextTrack>;
  paused(): boolean;
}

export interface BrightcovePlayerMediaInfo {
  id: string;
  duration: number;
  cuePoints: Array<BrightcoveCue>;
}

export interface BrightcoveDataSettings {
  title: boolean;
  sharing: boolean;
  endSlate: boolean;
  embedCode: boolean;
  playlist: boolean;
}

export interface BrightcoveTextTrack {
  activeCues: Array<BrightcoveCue>;
  oncuechange(callback: (() => void)): void;
}

export interface BrightcoveCue {
  id: string;
  name: string;
  type: string;
  text: string;
  startTime: number;
  endTime: number;
}

export interface BrightcovePlayerCatalog {
  getVideo(videoId: string, callback: ((error: string, video: BrightcovePlayerMediaInfo) => void)): void;
  load(video: BrightcovePlayerMediaInfo): void;
}
